import{__exports as o}from"../../../_virtual/well-known-symbol-wrapped.js";import{__exports as t}from"../../../_virtual/well-known-symbol-wrapped.js";import l from"./well-known-symbol.js";var r=l;o.f=r;export{t as default};
